module.exports = __webpack_public_path__ + "img/cancel.155d3657.svg";